import React, { PureComponent, useState, useEffect, useRef } from "react";
import {
  Form,
  Button,
  Col,
  Row,
  message,
  Modal,
  Input,
  Select,
  Radio,
  Space,
  DatePicker,
} from "antd";
import { useHistory } from "react-router-dom";
import message01 from "images/soldier/message1.png";
import { Link } from "react-router-dom";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
import nb from "../../img/nb.png";
import { getCurrentUser, getDictOne, getCitys } from "utils/storage";
import moment from "moment";
import zh_CN from "antd/lib/date-picker/locale/zh_CN";
import "moment/locale/zh-cn";
import Cascader from "@/components/Cascader";
import { getStatus } from "@/utils/methods";

import ApproveModal from "@/components/ApproveModal";
import { get } from "mobx";
moment.locale("zh-cn");
const FormItem = Form.Item;
const { TextArea } = Input;
const { Option } = Select;
const cityList = getCitys();
// const newCityList = ()=>{
//   cityList && cityList.map((item)=>{
//       let list = []
//       if(item.id == '510000000000'){
//         item.children.map((Option)=>{
//           if(Option.id == '511400000000'){
//             list = Option.children
//           }
//         })
//       }
//       console.log('list',list);

//       return list
//   })
// }
require("./createAssistItem.scss");
const codeList = getDictOne("marit_sta_code");
const codeList2 = getDictOne("fund_type");

export default function DeucationTrainingPolicyDetail(props) {
  const [form] = Form.useForm();
  const [sourseId, setSourseId] = useState("");
  const [courseInfo, setCourseInfo] = useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [checkValue, setCheckValue] = useState(1);
  const [selectData, setSelectData] = useState("");

  const history = useHistory();
  const modalRef = useRef([]);
  useEffect(() => {
    let sourseId = props.location.pathname.split("/").slice(-1);
    getDetail(sourseId[0]);
    setSourseId(sourseId[0]);
  }, [props.location.pathname]);
  //获取详情
  const getDetail = (data) => {
    console.log("id信息", data);
    let params = {
      id: data,
    };
    Http.getApplication(
      Request.detailSinglePage("msjycy_cybf_jj"),
      {},
      (obj) => {
        console.log(obj);
        if (obj.code == 200) {
          setCourseInfo(obj.data);
        }
      }
    );
  };
  const toArticle = () => {
    history.push({
      pathname: "/entrance/entrepreneurship/FinancialServiceArticle",
      state: { id: "msjycy_cybf_jj_xq" },
    });
    // this.props.history.push({
    //   pathname: "/entrance/educationPoliciesDetails",
    //   state: { id: "msjycy_jypxzc23" },
    // })
  };
  const showModal = (e) => {
    message.config({
      top: 50,
      duration: 1,
      maxCount: 1,
    });
    if (getCurrentUser().user_type != "2") {
      message.warn("非退役军人不可申请!");
      return;
    }
    getStatus().then((res) => {
      if (res === false) {
        modalRef.current.showModal();
        return;
      }
      e.stopPropagation();
      setModalVisible(true);
    });
  };
  const handleOk = (e) => {
    let sourseId = props.location.pathname.split("/").slice(-1);
    const userInfo = getCurrentUser();
    console.log("userInfo", userInfo);

    const formValue = form.getFieldsValue(true);
    if (formValue.businessAddressCode) {
      if (!formValue.businessAddressCode.cityId) {
        message.error("地区选择必须精确到县级");
        return;
      } else {
        let idArr = `${formValue.businessAddressCode.provinceId},${formValue.businessAddressCode.cityId}`;
        let nameArr = `${formValue.businessAddressCode.provinceName},${formValue.businessAddressCode.cityName}`;
        formValue.businessAddressName = nameArr;
        formValue.businessAddressCode = idArr;
      }
    }
    console.log("formValue", formValue, userInfo);
    let params = formValue;
    Http.post(
      Request.financialBaseApplyNew(),
      { ...params, id: userInfo.user_id, fundId: sourseId[0] },
      (obj) => {
        if (obj.code == 200) {
          message.success("申请成功", 2);
        }
      }
    );
    setModalVisible(false);
  };
  const handleCancel = () => {
    setModalVisible(false);
  };
  const handleChange = (e) => {
    console.log("e", e);
    setSelectData(e);
  };
  const onChange = (e) => {
    setCheckValue(e.target.value);
  };
  const list = [
    {
      label: "姓名",
      name: "applyName",
      value: courseInfo?.applyName || "",
      type: "input",
      require: true,
      placeholder: "请输入姓名",
    },
    {
      label: "身份证号码",
      name: "applyCard",
      value: courseInfo?.applyCard || "",
      type: "input",
      require: true,
      placeholder: "请输入身份证号码",
    },
    {
      label: "实际住址",
      name: "reallyAddress",
      value: courseInfo?.reallyAddress || "",
      type: "input",
      require: true,
      placeholder: "请输入实际住址",
    },
    {
      label: "退役证号码",
      name: "retireCardNum",
      value: courseInfo?.retireCardNum || "",
      type: "input",
      require: true,
      placeholder: "请输入退役证号码",
    },
    {
      label: "联系电话",
      name: "applyPhone",
      value: courseInfo?.applyPhone || "",
      type: "input",
      require: true,
      placeholder: "请输入联系电话",
    },
    {
      label: "婚姻状况",
      name: "marriageStatus",
      value: courseInfo?.marriageStatus || "",
      type: "select",
      require: true,
      placeholder: "请选择婚姻状况",
    },
    {
      label: "申请人配偶",
      name: "spouseName",
      value: courseInfo?.spouseName || "",
      type: "input",
      require: true,
      placeholder: "请输入申请人配偶姓名",
    },
    {
      label: "申请人配偶身份证号",
      name: "spouseCard",
      value: courseInfo?.spouseCard || "",
      type: "input",
      require: true,
      placeholder: "请输入申请人配偶身份证号码",
    },
    {
      label: "申请人配偶联系电话",
      name: "spousePhone",
      value: courseInfo?.spousePhone || "",
      type: "input",
      require: true,
      placeholder: "请输入申请人配偶联系电话",
    },
    {
      label: "申请资助金额",
      name: "fundNum",
      value: courseInfo?.fundNum || "",
      type: "input",
      require: true,
      placeholder: "请输入申请资助金额",
    },
    {
      label: "经营项目",
      name: "managementDemo",
      value: courseInfo?.managementDemo || "",
      type: "input",
      require: true,
      placeholder: "请输入经营项目",
    },
    {
      label: "工商营业执照号码",
      name: "businessLicenseCard",
      value: courseInfo?.businessLicenseCard || "",
      type: "input",
      require: true,
      placeholder: "请输入工商营业执照号码",
    },
    {
      label: "经营地址",
      name: "businessAddressCode",
      value: courseInfo?.businessAddressCode || "",
      type: "cascader",
      require: true,
      placeholder: "请输入经营地址",
    },
    {
      label: "申请类型",
      name: "fundType",
      value: courseInfo?.fundType || "",
      type: "radio",
      require: true,
      placeholder: "请选择申请类型",
    },
    // {
    //   label: "创业资金名称",
    //   name: "fundName",
    //   value:courseInfo?.fundName || '',
    //   type: "input",
    //   require: true,
    //   placeholder: "请输入资金名称"
    // },
    // {
    //   label: "发布单位",
    //   name: "releaseUnit",
    //   value:courseInfo?.releaseUnit || '',
    //   type: "input",
    //   require: true,
    //   placeholder: "请输入发布单位"
    // },

    // {
    //   label: "发布时间",
    //   name: "releaseTime",
    //   value:courseInfo?.releaseTime || '',
    //   type: "time",
    //   require: true,
    //   placeholder: "请选择奖发布时间"
    // },
    // {
    //   label: "创业资金简介",
    //   name: "fundIntroduce",
    //   value:courseInfo?.fundIntroduce || '',
    //   type: "input",
    //   require: true,
    //   placeholder: "请输入创业资金简介"
    // },
    // {
    //   label: "贷款金额",
    //   name: "fundRange",
    //   value:"",
    //   type: "inputTwo",
    //   require: true,
    //   placeholder: "请输入贷款金额"
    // },
    // {
    //   label: "申请时间",
    //   name: "createTime",
    //   value:courseInfo?.createTime || '',
    //   type: "time",
    //   require: true,
    //   placeholder: "请输入申请时间"
    // },
  ];
  const spectionApplication = () => {
    let newCityList = [];
    cityList &&
      cityList.map((item) => {
        if (item.id == "510000000000") {
          item.children.map((Option) => {
            if (Option.id == "511400000000") {
              newCityList = Option;
            }
          });
        }
      });
    console.log("newCityList", newCityList);

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    console.log("courseInfocourseInfo", courseInfo.fundName);
    console.log("marriageStatus", form.getFieldsValue(true).marriageStatus);

    return (
      <Form form={form}>
        <Row>
          {list.map((item, index) => {
            if (form.getFieldsValue(true).marriageStatus != "20") {
              if (
                item.name == "spouseName" ||
                item.name == "spousePhone" ||
                item.name == "spouseCard"
              ) {
                return;
              }
            }
            console.log("marriageStatus", form.getFieldValue("marriageStatus"));

            if (item.type == "input") {
              return (
                <Col span={12}>
                  <Form.Item
                    name={item.name}
                    initialValue={item.value}
                    {...formItemLayout}
                    label={item.label}
                  >
                    <Input
                      placeholder={item.placeholder}
                      // disabled={true}
                    />
                  </Form.Item>
                </Col>
              );
            } else if (item.type == "inputTwo") {
              return (
                <Col span={12}>
                  <Form.Item
                    name={item.name}
                    initialValue={item.value}
                    {...formItemLayout}
                    label={item.label}
                  >
                    <Input placeholder={item.placeholder} />
                  </Form.Item>
                </Col>
              );
            } else if (item.type == "TextArea") {
              return (
                <Col span={12}>
                  <Form.Item
                    name={item.name}
                    initialValue={item.value}
                    {...formItemLayout}
                    label={item.label}
                  >
                    <TextArea placeholder={item.placeholder} />
                  </Form.Item>
                </Col>
              );
            } else if (item.type == "select") {
              console.log("codeList", codeList);

              return (
                <Col span={12}>
                  <Form.Item
                    name={item.name}
                    initialValue={item.value}
                    {...formItemLayout}
                    label={item.label}
                  >
                    <Select defaultValue="lucy" onChange={handleChange}>
                      {codeList && codeList.length
                        ? codeList.map((item) => {
                            return (
                              <Option key={item.id} value={item.dictKey}>
                                {item.dictValue}
                              </Option>
                            );
                          })
                        : ""}
                    </Select>
                  </Form.Item>
                </Col>
              );
            } else if (item.type == "radio") {
              console.log("codeList2", codeList2);

              return (
                <Col span={12}>
                  <Form.Item
                    name={item.name}
                    {...formItemLayout}
                    label={item.label}
                  >
                    <Radio.Group onChange={onChange} value={checkValue}>
                      {codeList2 && codeList2.length
                        ? codeList2.map((item) => {
                            return (
                              <Radio key={item.id} value={item.dictKey}>
                                {item.dictValue}
                              </Radio>
                            );
                          })
                        : ""}
                    </Radio.Group>
                  </Form.Item>
                </Col>
              );
            } else if (item.type == "time") {
              return (
                <Col span={12} locale={zh_CN}>
                  <Form.Item
                    name={item.name}
                    defaultValue={item.value}
                    {...formItemLayout}
                    label={item.label}
                  >
                    <DatePicker style={{ width: "100%" }} locale={zh_CN} />
                  </Form.Item>
                </Col>
              );
            } else if (item.type == "cascader") {
              return (
                <Col span={12} locale={zh_CN}>
                  <Form.Item
                    name={item.name}
                    defaultValue={item.value}
                    {...formItemLayout}
                    label={item.label}
                  >
                    <Cascader option={[newCityList]} bespread allCitys />
                  </Form.Item>
                </Col>
              );
            }
          })}
        </Row>
      </Form>
    );
  };

  console.log("courseInfo", courseInfo == "");
  const courseList = [
    {
      name: "产品名称",
      value: courseInfo == "" ? courseInfo.trainingName : "退役军人专项贷款-1",
    },
    {
      name: "产品类别",
      value: courseInfo == "" ? courseInfo.major : "退军人就创业贷款",
    },
    {
      name: "发布时间",
      value: courseInfo == "" ? courseInfo.trainingIocations : "2022年10月23日",
    },
    // {
    //     name:'优惠政策',
    //     value:[
    //       {
    //         value:"1、助力退役军人再就业，日息低至0.0008%。",
    //       },
    //       {
    //         value:"2、贷款5年内免息还款",
    //       },
    //       {
    //         value:"3、只服务于退役军人",
    //       },
    //     ]
    // },
  ];
  return (
    <div className="FinancialServiceDetails_app">
      <div className="Base_Detils_Box">
        <span>当前位置：创业帮扶 / 创业金融服务 / </span>
        <span style={{ color: "#3356C5" }}> 创业基金详情</span>
      </div>
      <div className="conBox">
        <div className="topbox">
          <div className="right">
            <div className="courseInfoBox">
              {/* <span className='courseName'>{courseInfo.courseName}</span> */}
              <span className="btnBox">
                <span className="courseInfoList_top">
                  {courseInfo.fundName}
                </span>
                <div>
                  {/* <Button type='primary' className='leftBtn' onClick={(e)=>{showModal(e)}}>确认申请</Button> */}
                  <Button
                    onClick={() => {
                      history.goBack();
                    }}
                  >
                    返回
                  </Button>
                </div>
              </span>
            </div>

            <div className="fundInfoList">
              <div className="ftit">创业基金名称</div>
              <span className="fcon">{courseInfo.title}</span>
              <div className="ftit">创业基金政策</div>
              <div onClick={() => toArticle()}>
                <span
                  className="fcon"
                  style={{ color: "#C10000", cursor: "pointer" }}
                >
                  {courseInfo.alias}
                </span>
              </div>
              <div className="ftit">基金简介</div>
              <div dangerouslySetInnerHTML={{ __html: courseInfo?.content }} />
            </div>
          </div>
        </div>
      </div>
      <Modal
        title="申请金融产品"
        visible={modalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={"确认申请"}
        width={850}
      >
        {spectionApplication()}
      </Modal>
      <ApproveModal ref={modalRef} />
    </div>
  );
}
